var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClockOutline20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.036 8a1 1 0 012 0v1.739l1.2.841a1 1 0 01-1.146 1.639l-1.635-1.145a1 1 0 01-.415-.976A1.014 1.014 0 019.036 10V8z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-2 0a6 6 0 11-12 0 6 6 0 0112 0z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMDM1NTUgOEM5LjAzNTU1IDcuNDQ3NzIgOS40ODMyNyA3IDEwLjAzNTYgN0MxMC41ODc4IDcgMTEuMDM1NiA3LjQ0NzcyIDExLjAzNTYgOFY5LjczODk1TDEyLjIzNjkgMTAuNTgwMUMxMi42ODkzIDEwLjg5NjkgMTIuNzk5MyAxMS41MjA1IDEyLjQ4MjUgMTEuOTcyOUMxMi4xNjU3IDEyLjQyNTMgMTEuNTQyMiAxMi41MzUyIDExLjA4OTggMTIuMjE4NUw5LjQ1NDcxIDExLjA3MzZDOS4xMzEyMyAxMC44NDcxIDguOTgyODQgMTAuNDYzNyA5LjA0MDMyIDEwLjA5ODNDOS4wMzcxNyAxMC4wNjU5IDkuMDM1NTUgMTAuMDMzMiA5LjAzNTU1IDEwVjhaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOCAxMEMxOCAxNC40MTgzIDE0LjQxODMgMTggMTAgMThDNS41ODE3MiAxOCAyIDE0LjQxODMgMiAxMEMyIDUuNTgxNzIgNS41ODE3MiAyIDEwIDJDMTQuNDE4MyAyIDE4IDUuNTgxNzIgMTggMTBaTTE2IDEwQzE2IDEzLjMxMzcgMTMuMzEzNyAxNiAxMCAxNkM2LjY4NjI5IDE2IDQgMTMuMzEzNyA0IDEwQzQgNi42ODYyOSA2LjY4NjI5IDQgMTAgNEMxMy4zMTM3IDQgMTYgNi42ODYyOSAxNiAxMFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgClockOutline20 as ReactComponent };